import { FC } from "react"
import PreferencesRow from "../PreferencesRow"
import Dropdown, { DropdownOption } from "@/components/shared/Dropdown"
import { Variant } from "@/types/index"

interface CardSizeDropdownProps {
   title: string
   description: string
   dropdownLabel: string
   options: DropdownOption[]
   onChange: (value: string) => void
}

const CardSizeDropdown: FC<CardSizeDropdownProps> = ({
   title,
   description,
   dropdownLabel,
   options,
   onChange,
}) => {
   return (
      <PreferencesRow
         title={title}
         description={description}
      >
         <Dropdown
            size={Variant.LARGE}
            label={dropdownLabel}
            options={options}
            onSelectionChange={(value) => onChange(value[0])}
         />
      </PreferencesRow>
   )
}

export default CardSizeDropdown
